export const AFFILIATLY_CURRENCY = 'gbp';
export const AFFILIATLY_ID = 'AF-105152';
export const API_URL = 'https://api.musicgurus.com';
export const AWIN_ADVERTISER_ID = 23000;
export const AWIN_CHANNEL = 'aw';
export const AWIN_COMMISSION_GROUP_CODE = 'Default';
export const AWIN_IS_TEST = 0;
export const DASHBOARD_URL = 'https://dashboard.musicgurus.com';
export const MIXPANEL_TOKEN = '628028cdbbcd036d3847d25a10dcff62';
export const PAYPAL_CLIENT_ID = 'AeGKvQZGiood8ZX59UItVh6r4NjmYJt7xE201jpu2csDkVbQ07F226H3mz_Lh6Ol57q4hQB5GtJLx3-S';
export const SENTRY_DEBUG_MODE = false;
export const SENTRY_DSN = 'https://bf5d831226944fe7b5d32f25b4098639@o171242.ingest.sentry.io/5608479';
export const SENTRY_ENV = 'production';
export const SENTRY_TRACES_SAMPLE_RATE = 0.1;